<div class="settings-container">
  <!-- Header -->
  <div class="settings-header bg-white border-bottom py-4 px-4">
    <h1 class="mb-0">Settings</h1>
  </div>

  <!-- Tab Navigation -->
  <app-page-tabs
    [tabs]="tabs"
    [activeTab]="activeTab()"
    (tabChange)="onTabChange($event)"
  />

  <!-- Scrollable Content -->
  <div class="settings-content">
    <div class="container-fluid p-4">
      @if (activeTab() === 'audit-log') {
        <app-audit-log />
      }
    </div>
  </div>
</div>
